import { CRM_ITEM_DETAILED_VIEW_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const MIN_PIN_LENGTH = 8

export const PIN_SPECIAL_CHARACTERS = new Set(
   '!@#$%^&*()_+-=[]{}|;\':",./<>?~`'
)

export const IMAGE_URLS = {
   PIN_NOT_CREATED_ICON: `${CRM_ITEM_DETAILED_VIEW_BASE_URL_PREFIX}/images/pin-not-configured.png`
}
